<template>
  <div>
    <!-- <span class="logo-mx3">MX3</span> <span class="logo-network">NETWORK</span> -->
    <!-- Logomarca da Import Mais Brasil: "empilhada" (globo + nome) no cabeçalho grande
         do computador e "larga" (nome em linha) nas demais situações. A troca é feita
         por CSS (ver App.vue / Header.vue), sem recarregar imagens. -->
    <img class="logo-site-img logo-wide" :class="{ 'logo-footer-fixed': forceDark }" src="/img/logo-importmaisbrasil-wide.png" alt="Import Mais Brasil">
    <img class="logo-site-img logo-stacked" :class="{ 'logo-footer-fixed': forceDark }" src="/img/logo-importmaisbrasil-stacked.png" alt="Import Mais Brasil" aria-hidden="true">
  </div>
</template>

<script>
export default {
  props: {
    // Rodapé sempre usa a logomarca do tema escuro (pedido explícito),
    // mesmo quando o site está no tema claro.
    forceDark: { type: Boolean, default: false },
  },
  data() {
    return {
      // Tema escuro mantém a logomarca original (new-logo.webp) sem
      // alteração. Tema claro usa a logomarca clara dedicada
      // (new-logo-light.webp), enviada especificamente para isso -
      // exceto quando forceDark=true (rodapé).
      //
      // Quando a página está sendo carregada dentro do iframe de
      // pré-visualização da tela "Personalizar" (Gerenciador de Produtos),
      // o tema exibido é forçado via query string (?mx3_preview_theme=dark
      // ou light) independente do que estiver salvo no localStorage deste
      // navegador - do contrário, ao pré-visualizar o Tema Escuro, a logo
      // podia continuar aparecendo na versão clara (ou vice-versa) se o
      // admin estivesse com o outro tema ativo na própria sessão. Mesma
      // lógica usada em App.vue para decidir o tema geral da pré-visualização.
      isDarkTheme: (() => {
        const previewTheme = new URLSearchParams(window.location.search).get("mx3_preview_theme");
        return previewTheme ? previewTheme !== "light" : localStorage.getItem("siteTheme") !== "light";
      })(),
    };
  },
  computed: {
  },
  created() {
    this.$root.$on("mx3-theme-changed", this.onThemeChanged);
  },
  beforeDestroy() {
    this.$root.$off("mx3-theme-changed", this.onThemeChanged);
  },
  methods: {
    onThemeChanged(isDark) {
      this.isDarkTheme = isDark;
    },
  },
}
</script>

<style lang="scss">
.logo-site-img{
  height: 50px;
  margin-top: 0px;
}

/* Desktop: Aumentar tamanho da logo */
@media (min-width: 769px) {
  .logo-site-img {
    height: 85px !important;
  }
}

/* Rodapé (force-dark): logomarca completa (globo + textos), igual à versão de
   referência 2908_74. A versão "larga" (somente o nome) é ocultada no rodapé. */
html body .logo-site-img.logo-wide.logo-footer-fixed {
  display: none !important;
}
html body .logo-site-img.logo-stacked.logo-footer-fixed {
  display: block !important;
  /* Tamanho (altura) e posição editáveis em Personalizar ao clicar na logomarca
     do rodapé: --mx3-footer-logo-height / -top / -left. */
  height: var(--mx3-footer-logo-height, auto) !important;
  width: auto !important;
  max-height: var(--mx3-footer-logo-height, 80px) !important;
  max-width: 100% !important;
  object-fit: contain;
  position: relative;
  top: var(--mx3-footer-logo-top, 0px);
  left: var(--mx3-footer-logo-left, 0px);
}

</style>
